import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { URLS } from "../../redux/api/Constants";
import { get, post } from "../../redux/api/ApiHandler";
import moment from "moment";
import useSearchFunction from "../../../Component/searchFunction";
const PendingTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  // const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [count, setCount] = useState(0);

  const debounceval = useSearchFunction(searchValue);

  // const [selFrom, setSelFrom] = useState("");
  // const [selTo, setSelTo] = useState("");

  // const handleStatus = (row) => {
  //   const updatedData = [...owners];
  //   const index = row.index; // Get current row index
  //   const currentStatus = updatedData[index].status || "on";
  //   updatedData[index].status = currentStatus === "on" ? "off" : "on";
  //   setOwners(updatedData);
  // };

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);

    let payload = {
      search: search,
      // page: page,
      region_id: selected?.value,
      type: 2,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      // setList(res?.lists);
      let array = [3, 5, 7, 11, 14];
      let arr = res?.lists.filter((item) =>
        array.includes(item?.current_status),
      );
      console.log("filArr", arr);
      setList(arr);
      setCount(arr.length);
      setPagination(res?.pagination_meta);
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval, page]);

  // const [owners, setOwners] = useState([
  //   {
  //     reginalid: "RGT-001",
  //     region: "North",
  //     regionalmanager: "Arun Kumar",
  //     servicemanager: "Priya Singh",
  //     customerid: "CUST-101",
  //     customername: "ABC Technologies",
  //     createdby: "Robert-Service Engineer",
  //     date: "2025-10-13",
  //     status: "on",
  //   },
  //   {
  //     reginalid: "RGT-002",
  //     region: "South",
  //     regionalmanager: "Vikram Das",
  //     servicemanager: "Anjali Mehta",
  //     customerid: "CUST-102",
  //     customername: "XYZ Pvt Ltd",
  //     createdby: "Thor-Regional Manager",
  //     date: "2025-10-12",
  //     status: "off",
  //   },
  //   {
  //     reginalid: "RGT-003",
  //     region: "East",
  //     regionalmanager: "Rahul Verma",
  //     servicemanager: "Sneha Reddy",
  //     customerid: "CUST-103",
  //     customername: "Bright Solutions",
  //     createdby: "John-Service Engineer",
  //     date: "2025-10-11",
  //     status: "on",
  //   },
  //   {
  //     reginalid: "RGT-004",
  //     region: "West",
  //     regionalmanager: "Neha Kapoor",
  //     servicemanager: "Karan Shah",
  //     customerid: "CUST-104",
  //     customername: "Omni Systems",
  //     createdby: "Alice-Service Engineer",
  //     date: "2025-10-10",
  //     status: "off",
  //   },
  // ]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region Type",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },
      {
        Header: "Request Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-js">
              <button
                // onClick={() => handleStatus(row)}
                className={`${
                  value == 5
                    ? "technical_btn"
                    : value == 3
                      ? "inventory_button"
                      : value == 7
                        ? "dispatched_btn"
                        : "yet_to_start_btn"
                } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
              >
                {value === 5
                  ? "Technical"
                  : value === 3
                    ? "Inventory"
                    : value === 7
                      ? "Next Visit"
                      : value === 9
                        ? "Senior Support"
                        : value === 14
                          ? "Super Admin"
                          : value === 11
                            ? "Senior Support"
                            : ""}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc mt-2 gap-3">
                <button
                  onClick={() => {
                    navigate("/pending-view", {
                      state: {
                        type: "view",
                        id: row?.original?.id,
                        status: row?.original?.current_status,
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view} alt="" className=" editor-btn " />
                </button>
                {row?.original?.current_status != 7 && (
                  <button
                    onClick={() => {
                      navigate("/pending-view", {
                        state: {
                          type: "edit",
                          id: row?.original?.id,
                          status: row?.original,
                        },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit} alt="" className=" editor-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar header={"Pending"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total Count :{count}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, selected, fromDates, val)
            }
          />

          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) =>
                setSearchValue(e.target.value, selected, fromDates, toDates)
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          // pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default PendingTable;
